import { MatIconModule } from '@angular/material/icon';
import { SharedModule } from './../shared/shared.module';
import { NgbActiveModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import  AzureDevopsService  from '../shared/services/azuredevops.service';
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, NgForm, FormControl, FormsModule } from '@angular/forms';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { WebappsWithPulumiComponent } from './components/webapps-with-pulumi/webapps-with-pulumi.component';
import {MatExpansionModule} from '@angular/material/expansion';
import { ManageDependenciesModalComponent } from './components/manage-dependencies-modal/manage-dependencies-modal.component';
import {MatDialogModule} from '@angular/material/dialog';
import {MatSelectModule} from '@angular/material/select';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatTooltipModule } from '@angular/material/tooltip';
import {MatListModule} from '@angular/material/list';
import { PulumiProjectsListComponent } from './components/pulumi-projects-list/pulumi-projects-list.component';

@NgModule({
  declarations: [   
    WebappsWithPulumiComponent,    
    ManageDependenciesModalComponent,  
    PulumiProjectsListComponent
  ],
  imports: [   
    MatListModule,
    MatTooltipModule,
    MatIconModule,
    NgSelectModule,    
    MatSelectModule,
    MatDialogModule,
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatInputModule,
    NgbModule,
    ReactiveFormsModule,
    SharedModule,
    FormsModule,
    MatExpansionModule
  ],
  providers: [
    AzureDevopsService,
    NgbActiveModal
  ]
})
export class PulumiModule { }
